'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.caselist = twentyninetimes.caselist || function () {
  
  function init() {
    var caseListElem = document.getElementById('js-case-list');

    if(caseListElem) {
    // Replace these variables with your own values
      const siteUrl = 'http://jsworldmedia.local';
      const customPostType = 'case';
      const postsPerPage = 4;

      let pageNumber = 1; // Page number you want to retrieve

      const loadMoreButton = document.getElementById('loadMoreButton');

      if(loadMoreButton) {
        loadMoreButton.addEventListener('click', loadMoreItems);
      }

      // Load initial items on page load
      window.addEventListener('load', () => {
        loadItems();
      });
    }
	}

  function loadItems() {
    const offset = (pageNumber - 1) * postsPerPage;
    const apiUrl = `${siteUrl}/wp-json/wp/v2/${customPostType}?offset=${offset}&per_page=${postsPerPage}&_embed`;
    
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const caseListContainer = document.getElementById('js-case-list');
        // console.log(data);
        
        // Loop through the portfolio items
        data.forEach(item => {
          // Retrieve data for each item
          const title = item.title.rendered;
          const link = item.link;
          const categories = item.tax_case;
          const thumbnailLayout = item.acf.case_thumbnail_layout;

          var featuredImage = '';
          if (item.hasOwnProperty('featured_media') && item.featured_media !== 0) {
            featuredImage = item._embedded['wp:featuredmedia'][0];
          }
          // const taxonomyNames = Object.keys(item.taxonomyNames).map(taxonomy => item.taxonomyNames[taxonomy]);


          // Create a new div element to hold the item's content
          const portfolioItem = document.createElement('div');
          portfolioItem.className = 'item-case';
          
          // Create inner HTML for the portfolio item
          // portfolioItem.innerHTML = `
          //   <div class="item-case__inner">
          //   ${title}
          //   </div>
          // `;
          portfolioItem.innerHTML = itemHtml(title, link, categories, featuredImage, thumbnailLayout);
          // Append portfolioItem to the caseListContainer
          caseListContainer.appendChild(portfolioItem);
        });

        // Increment the page number
        pageNumber++;


        // If there are no more items, hide the load more button
        if (data.length < postsPerPage) {
          loadMoreButton.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error retrieving data from WordPress API:', error);
      });
  }

  function itemHtml(title, link, categories, featuredImage, thumbnailLayout) {
    var featuredImageUrl = featuredImage.source_url;
    var featuredImageSrcset = '';

    if (featuredImage.hasOwnProperty('media_details') && featuredImage.media_details.hasOwnProperty('sizes')) {
      var sizes = featuredImage.media_details.sizes;
      var srcset = [];
      for (var size in sizes) {
        srcset.push(sizes[size].source_url + ' ' + sizes[size].width + 'w');
      }
      featuredImageSrcset = srcset.join(', ');
    }

    var htmlString = `
      <div class="item-case item-case--${thumbnailLayout}">
        <div class="item-case__inner">
      `;

      if(featuredImage) {

        htmlString += `
          <a href="${link}" title="${title}">
            <figure class="item-case__image image-cover"><img src="${featuredImageUrl}" srcset="${featuredImageSrcset}" title="${title}"></figure>
          </a>
        `;
      }

        htmlString += `
          <div class="item-case__categories">categories</div>
          <div class="item-case__content">
            <h4 class="item-case__content-header"><a href="${link}" title="${title}">${title}${thumbnailLayout}</a></h4>
          </div>
        </div>
      </div>
    `;
    return htmlString;
  }

  function loadMoreItems() {
    loadItems();
  }

	return {
		init : init
	};

}();